import React from "react";
import { createBrowserRouter } from "react-router-dom";
import RootLayout from "../Layout/Rootlayout";
import Register from "../Auth/RegisterPage/RegisterPage";
import LoginPage from "../Auth/Login/LoginPage";
import AboutPage from "../Components/AboutPage/AboutPage";
import HomePage from "../Components/HomePage/HomePage";
import CoursePage from "../Components/CoursePage/CoursePage";
import ModuleOne from "../COURSES/DroneModules/ModuleOne/ModuleOne";
import ModuleTwo from "../COURSES/DroneModules/ModuleTwo/ModuleTwo";
import ForgotPassword from "../Auth/ForgotPassword/ForgotPassword";
import ResetPassword from "../Auth/ResetPassword/ResetPassword";
import ProfilePage from "../Auth/ProfilePage/ProfilePage";
import AiCoursePage from "../Components/AiCoursePage/AiCoursePage";
import AiModuleOne from "../COURSES/AiModules/AiModuleOne/AiModuleOne";
import ModuleThree from "../COURSES/DroneModules/ModuleThree/ModuleThree";
import ModuleFour from "../COURSES/DroneModules/ModuleFour/ModuleFour";
import ModuleFive from "../COURSES/DroneModules/ModuleFive/ModuleFive";
import AiModuleTwo from "../COURSES/AiModules/AiModuleTwo/AiModuleTwo";
import AiModuleThree from "../COURSES/AiModules/AiModuleThree/AiModuleThree";
import AiModuleFour from "../COURSES/AiModules/AiModuleFour/AiModuleFour";
import AiModuleFive from "../COURSES/AiModules/AiModuleFive/AiModuleFive";
import StudentPage from "../STUDENTPLATFORM/StudentPage/StudentPage";
import ProtectedRoute from "../Components/ProtectedRoute/ProtectedRoute";
import PageNotFound from "../Components/PageNotFound/Error";


const router = createBrowserRouter([
  {
    path: "/",
    element: <RootLayout />,
    children: [
      { index: true, element: <LoginPage /> },
      { path: "login", element: <LoginPage /> },
      { path: "register", element: <Register /> },
      { path: "forgot-password", element: <ForgotPassword /> },
      { path: "reset-password/:token", element: <ResetPassword /> },
     { path: "student_form", element: <StudentPage /> },
      { path: "about", element: <AboutPage /> },
      {path:"*", element:<PageNotFound/>},
      // 👇 Protected group
      {
        element: <ProtectedRoute />,
        children: [
          { path: "home", element: <HomePage /> },
         
          { path: "drone_course", element: <CoursePage /> },
          { path: "ai_course", element: <AiCoursePage /> },
          { path: "module_one_drone_intro", element: <ModuleOne /> },
          { path: "module_one_drone_level_two", element: <ModuleTwo /> },
          { path: "module_one_drone_level_three", element: <ModuleThree /> },
          { path: "module_one_drone_level_four", element: <ModuleFour /> },
          { path: "module_one_drone_level_five", element: <ModuleFive /> },
          { path: "ai_module_intro", element: <AiModuleOne /> },
          { path: "ai_module_core_two", element: <AiModuleTwo /> },
          { path: "ai_module_one_intro_three", element: <AiModuleThree /> },
          { path: "ai_module_one_intro_four", element: <AiModuleFour /> },
          { path: "ai_module_one_intro_five", element: <AiModuleFive /> },
          { path: "myprofile", element: <ProfilePage /> }
     
        ],
      },
    ],
  },
]);

export default router;
